import { Component, ReactNode, ErrorInfo } from 'react';

interface Props { children: ReactNode; }
interface State { error: Error | null; componentStack: string | null; }

export default class ErrorBoundary extends Component<Props, State> {
  declare state: State;
  declare props: Props;
  declare setState: Component<Props, State>['setState'];
  constructor(props: Props) {
    super(props);
    this.state = { error: null, componentStack: null };
  }
  static getDerivedStateFromError(error: Error): Partial<State> { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ componentStack: info.componentStack || null });
    console.error('[ErrorBoundary]', error, info.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ background: '#0a0a0a', color: '#fbbf24', fontFamily: 'monospace', padding: 32, height: '100vh', display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}>
          <div style={{ fontSize: 18, fontWeight: 'bold', letterSpacing: '0.2em' }}>SYSTEM FAULT</div>
          <div style={{ fontSize: 12, color: '#ef4444', maxWidth: 700, textAlign: 'center', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{String(this.state.error)}</div>
          <div style={{ fontSize: 10, color: '#888', maxWidth: 700, width: '100%', textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-all', overflow: 'auto', maxHeight: 180, background: '#111', padding: 8, border: '1px solid #333' }}>{(this.state.error as any)?.stack || 'No stack trace'}</div>
          {this.state.componentStack && (
            <div style={{ fontSize: 10, color: '#d4a843', maxWidth: 700, width: '100%', textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-all', overflow: 'auto', maxHeight: 150, background: '#111', padding: 8, border: '1px solid #d4a84333' }}>
              <div style={{ color: '#d4a843', marginBottom: 4 }}>Component stack:</div>
              {this.state.componentStack}
            </div>
          )}
          <button onClick={() => window.location.reload()} style={{ marginTop: 8, padding: '8px 24px', background: 'rgba(251,191,36,0.15)', border: '1px solid #fbbf24', color: '#fbbf24', cursor: 'pointer', fontFamily: 'monospace', letterSpacing: '0.15em' }}>REBOOT</button>
        </div>
      );
    }
    return this.props.children;
  }
}
